import { createFileRoute } from "@tanstack/react-router";

import { GroupAdminSettingsPanel } from "@/components/groups/group-admin";
import { useGroupRouteData } from "@/hooks/use-group-route-data";

export const Route = createFileRoute("/_authenticated/app/groups/$groupId/admin/")({
  component: GroupAdminSettingsTab,
});

function GroupAdminSettingsTab() {
  const { groupId, isAdmin, group } = useGroupRouteData(Route.useParams().groupId);

  if (!group || !isAdmin) return null;

  return (
    <div className="mx-auto max-w-180">
      <GroupAdminSettingsPanel
        groupId={groupId}
        companyId={group.companyId}
        groupName={group.name}
        groupDescription={group.description}
        groupPurpose={group.purpose}
        groupGuidance={group.guidance}
        groupCommunityType={group.communityType}
        allowAllUsersToPost={group.allowAllUsersToPost ?? false}
        allowAllUsersToComment={group.allowAllUsersToComment !== false}
        allowAllUsersToLike={group.allowAllUsersToLike !== false}
        enableResources={group.enableResources === true}
        isGlobal={group.isGlobal}
        visibility={group.visibility ?? (group.isPrivate ? "secret" : "public")}
      />
    </div>
  );
}
